export const issuedSummaryWeightProductBasedColumns = [
	{
		title: 'Product Name',
		key: 'productName',
	},
	{
		title: 'Price Per Unit',
		key: 'pricePerUnit',
	},
	{
		title: 'Ordered Quantity',
		key: 'orderedQuantity',
	},
	{
		title: 'Issued Quantity',
		key: 'issuedQuantity',
	},
	{
		title: 'Issuing %',
		key: 'issuingPercentage',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const issuedSummaryCostProductBasedColumns = [
	{
		title: 'Product Name',
		key: 'productName',
	},
	{
		title: 'Price Per Unit',
		key: 'pricePerUnit',
	},
	{
		title: 'Ordered Cost',
		key: 'orderedCost',
	},
	{
		title: 'Issued Cost',
		key: 'issuedCost',
	},
	{
		title: 'Ideal Cost',
		key: 'idealCost',
	},
	{
		title: 'Issued Cost %',
		key: 'issuedCostPercentage',
	},
	{
		title: 'Variance',
		key: 'variance',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const producedSummaryWeightOutletBasedColumns = [
	{
		title: 'Outlet Name',
		key: 'outletName',
	},
	{
		title: 'Ordered Qty',
		key: 'orderedQty',
	},
	{
		title: 'Actual Produced Qty',
		key: 'actualProducedQty',
	},
	{
		title: 'Production Cost Per Unit',
		key: 'productionPerKg',
	},
	{
		title: 'Production %',
		key: 'productionPercentage',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const producedSummaryCostOutletBasedColumns = [
	{
		title: 'Outlet Name',
		key: 'outletName',
	},
	{
		title: 'Ordered Cost',
		key: 'orderedCost',
	},
	{
		title: 'Actual Produced Cost',
		key: 'actualProducedCost',
	},
	{
		title: 'Production Cost per unit',
		key: 'productionCostPerUnit',
	},
	{
		title: 'Production %',
		key: 'productionPercentage',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const dispatchSummaryWeightOutletBasedColumns = [
	{
		title: 'Outlet Name',
		key: 'outletName',
	},
	{
		title: 'Po Id',
		key: 'poId',
	},
	{
		title: 'Ordered Qty',
		key: 'orderedQty',
	},
	{
		title: 'Packaged Qty (Packaged %)',
		key: 'packagedQty',
	},
	{
		title: 'Dispatched Qty (Dispatched %)',
		key: 'dispatchedQty',
	},
	{
		title: 'Received Qty (Received %)',
		key: 'receivedQty',
	},
	{
		title: 'Transit Time',
		key: 'transitTime',
	},
	{
		title: 'Vehicle No',
		key: 'vehicleNo',
	},
	{
		title: 'Vehicle Image',
		key: 'vehicleImg',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const dispatchSummaryCostOutletBasedColumns = [
	{
		title: 'Outlet Name',
		key: 'outletName',
	},
	{
		title: 'Ordered Amount',
		key: 'orderedAmount',
	},
	{
		title: 'Packaged Amount',
		key: 'packagedAmount',
	},
	{
		title: 'Dispatched Amount',
		key: 'dispatchedAmount',
	},
	{
		title: 'Received Amount',
		key: 'receivedAmount',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const restaurantIndentWeightSectionBasedColumns = [
	{
		title: 'Section Name',
		key: 'sectionName',
	},
	{
		title: 'Ordered Qty',
		key: 'orderedQty',
	},
	{
		title: 'Dispatched Qty (Dispatched %)',
		key: 'dispatchedQty',
	},
	{
		title: 'Left Over Qty (Left Over %)',
		key: 'leftOverQty',
	},
	{
		title: 'Consumed Qty (Consumed %)',
		key: 'consumedQty',
	},
	{
		title: 'Action',
		key: 'action',
	},
];
export const restaurantIndentCostSectionBasedColumns = [
	{
		title: 'Section Name',
		key: 'sectionName',
	},
	{
		title: 'Ordered Amount',
		key: 'orderedAmount',
	},
	{
		title: 'Dispatched Amount',
		key: 'dispatchedAmount',
	},
	{
		title: 'Left Over Amount',
		key: 'leftOverAmount',
	},
	{
		title: 'Consumed Amount',
		key: 'consumedAmount',
	},
	{
		title: 'Action',
		key: 'action',
	},
];

export const dropDownItems = [
	{
		label: 'ProductName',
		value: 'name',
		placeholder: 'Search by Product Name',
	},
	{
		label: 'Ingredient Name',
		value: 'ingredientName',
		placeholder: 'Search by Ingredient Name',
	},
	{
		label: 'Outlet Name',
		value: 'outletName',
		placeholder: 'Search by Outlet Name',
	},
	{
		label: 'Section Name',
		value: 'sectionName',
		placeholder: 'Search by Section Name',
	},
	{
		label: 'Intermediate Name',
		value: 'intermediateName',
		placeholder: 'Search by Intermediate Name',
	},
];

export const IssuedSortOptions = {
	productWeight: [
		{
			value: 'productName', label: 'Product Name', type: 'string',
		},
		{
			value: 'orderedQuantity', label: 'Ordered Quantity', type: 'number',
		},
		{
			value: 'issuedQuantity', label: 'Issued Quantity', type: 'number',
		},
		{
			value: 'issuingPercentage', label: 'Issuing %', type: 'number',
		},
	],
	productCost: [
		{
			value: 'productName', label: 'Product Name', type: 'string',
		},
		{
			value: 'orderedCost', label: 'Ordered Cost', type: 'number',
		},
		{
			value: 'issuedCost', label: 'Issued Cost', type: 'number',
		},
		{
			value: 'idealCost', label: 'Ideal Cost', type: 'number',
		},
		{
			value: 'issuedCostPercentage', label: 'Issued Cost %', type: 'number',
		},
		{
			value: 'variance', label: 'Variance', type: 'number',
		},
	],
};

export const producedSortOptions = {
	outletWeight: [
		{
			value: 'outletName', label: 'Outlet Name', type: 'string',
		},
		{
			value: 'orderedQty', label: 'Ordered Qty', type: 'number',
		},
		{
			value: 'actualProducedQty', label: 'Actual Produced Qty', type: 'number',
		},
		{
			value: 'idealProducedQty', label: 'Ideal Produced Qty', type: 'number',
		},
		{
			value: 'productionPerKg', label: 'Production/Kg', type: 'number',
		},
		{
			value: 'productionPercentage', label: 'Production %', type: 'number',
		},
	],
	outletCost: [
		{
			value: 'outletName', label: 'Outlet Name', type: 'string',
		},
		{
			value: 'orderedCost', label: 'Ordered Cost', type: 'number',
		},
		{
			value: 'actualProducedCost', label: 'Actual Produced Cost', type: 'number',
		},
		{
			value: 'idealProducedCost', label: 'Ideal Produced Cost', type: 'number',
		},
		{
			value: 'productionCostPerUnit', label: 'Production Cost per unit', type: 'number',
		},
		{
			value: 'productionPercentage', label: 'Production %', type: 'number',
		},
	],
};

export const dispatchSortOptions = {
	outletWeight: [
		{
			value: 'outletName', label: 'Outlet Name', type: 'string',
		},
		{
			value: 'orderedQty', label: 'Ordered Qty', type: 'number',
		},
		{
			value: 'packagedQty', label: 'Packaged Qty (Packaged %)', type: 'number',
		},
		{
			value: 'dispatchedQty', label: 'Dispatched Qty (Dispatched %)', type: 'number',
		},
		{
			value: 'consumedQty', label: 'Received Qty (Received %)', type: 'number',
		},
	],
	outletCost: [
		{
			value: 'outletName', label: 'Outlet Name', type: 'string',
		},
		{
			value: 'orderedAmount', label: 'Ordered Amount', type: 'number',
		},
		{
			value: 'packagedAmount', label: 'Packaged Amount', type: 'number',
		},
		{
			value: 'dispatchedAmount', label: 'Dispatched Amount', type: 'number',
		},
		{
			value: 'receivedAmount', label: 'Received Amount', type: 'number',
		},
	],
};

export const indentSortOptions = {
	sectionWeight: [
		{
			value: 'sectionName', label: 'Section Name', type: 'string',
		},
		{
			value: 'orderedQty', label: 'Ordered Qty', type: 'number',
		},
		{
			value: 'dispatchedQty', label: 'Dispatched Qty (Dispatched %)', type: 'number',
		},
		{
			value: 'leftOverQty', label: 'Left Over Qty (Left Over %)', type: 'number',
		},
		{
			value: 'consumedQty', label: 'Consumed Qty (Consumed %)', type: 'number',
		},
	],
	sectionCost: [
		{
			value: 'sectionName', label: 'Section Name', type: 'string',
		},
		{
			value: 'orderedAmount', label: 'Ordered Amount', type: 'number',
		},
		{
			value: 'dispatchedAmount', label: 'Dispatched Amount', type: 'number',
		},
		{
			value: 'leftOverAmount', label: 'Left Over Amount', type: 'number',
		},
		{
			value: 'consumedAmount', label: 'Consumed Amount', type: 'number',
		},
	],
};
export const costVarianceSortOptions = [
	{
		value: 'variance', label: 'Variance', type: 'number',
	},
	{
		value: 'costPrice', label: 'Cost Price', type: 'number',
	},
];
